import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthServiceService} from '../service/auth-service.service';
import {MsgServiceService} from '../service/msg-service.service';

export const defaultAuthGuardGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthServiceService);
  const msgService = inject(MsgServiceService);
  const router = inject(Router);

  if (authService.logado()) {
    const rotinasUrl: string[] = ['index', 'meus-documentos'];
    const modulos = authService.getModulos;

    if (modulos && Array.isArray(modulos)) {
      modulos.forEach((mod: any) => {
        if (mod && mod.rotinas && Array.isArray(mod.rotinas)) {
          rotinasUrl.push(...mod.rotinas.map((rot: any) => rot.url))
        }
      });

      if (rotinasUrl.length > 1 && !rotinasUrl.includes(route.url[0].path)) {
        msgService.msgAdvertencia('Você não tem acesso a essa rotina.');
        router.navigate(['/index']);
        return false;
      }
    }
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }

};
